<template>
    <div class="mb-4 py-4 border-b border-gray-400 tool-tile">
        <div class="flex flex-col sm:flex-row mb-4">
            <a :href="href" class="block w-full sm:w-48 h-64 sm:h-48 bg-gray-300 sm:mx-8 flex-shrink-0 bg-cover order-1 sm:order-0 mt-4 sm:mt-0" :style="imgStyle"></a>
            <div class="flex-grow-1 flex flex-col justify-between order-0 sm:order-1 px-4">
                <div>
                    <p class="text-2xl font-bold leading-none"><a :href="href" class="discrete"><span v-text="value.name"></span> <span class="icon-verified text-base text-ultramarine mx-2"></span></a></p>
                    <p class="text-xl mt-3"><a :href="href" class="icon-arrow--right"></a></p>
                </div>
                <div class="text-sm">
                    <ul v-if="value.level" class="flex flex-row flex-wrap -mx-1 mt-1 lg:-mx-2">
                        <li class="mx-1 lg:mx-2" v-text="$options.filters['lang']('copy.level') + ':'"></li>
                        <li  v-text="value.level.level_name" class="mx-1 lg:mx-2"></li>
                    </ul>
                    <ul v-if="value.keywords" class="flex flex-row flex-wrap -mx-1 mt-1 lg:-mx-2">
                        <li class="mx-1 lg:mx-2" v-text="$options.filters['lang']('copy.keywords') + ':'"></li>
                        <li v-for="keyword in value.keywords" class="mx-1 lg:mx-2"><a :href="getKeywordUrl(keyword)" v-text="keyword.keyword"></a></li>
                    </ul>

                    <ul v-if="value.languages" class="flex flex-row flex-wrap -mx-1 mt-1 lg:-mx-2">
                        <li class="mx-1 lg:mx-2" v-text="$options.filters['lang']('copy.languages') + ':'"></li>
                        <li v-for="language in value.languages" v-text="language.name" class="mx-1 lg:mx-2"></li>
                    </ul>
                </div>
            </div>
        </div>
        <p v-if="value.description" v-text="value.description" class="text-base mb-3 px-4"></p>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object
            }
        },
        computed: {
            href()
            {
                return '/tools/' + this.value.id + ',' + this.value.slug;
            },
            imgStyle()
            {
                const url = '/storage/tools/screenshots/' + this.value.id + '-1.png';
                return {
                    'background-image': 'url("' + url + '")',
                };
            },
            added()
            {
                const date = new Date(this.value.created_at);
                const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' });
                const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date);
                return `${day} ${month}`;
            }
        },
        methods: {
            getKeywordUrl(keyword)
            {
                return '/' + keyword.slug;
            }
        }
    };
</script>
